<template>
  <div class="footer_box">
    <div
      class="content_box h_100 d_flex align_items_center justify_content_between"
    >
      <div class="d_flex flex_column justify_content_center left_box">
        <p>400-160-3672</p>
        <div class="text_center" @click="toAboutUsPage">联系我们</div>
      </div>
      <div class="center_box">
        <div class="d_flex nav_box">
          <p
            v-for="(item, index) in navList"
            :key="index"
            class="nav_item"
            @click="navItemClick(item)"
          >
            {{ item.name }}
          </p>
        </div>
        <p>加盟电话：400-160-3672</p>
        <p>地址：北京市海淀区上地十街1号院</p>
        <a href="http://beian.miit.gov.cn/" target="_blank"
          >京ICP备2021012550号</a
        >
        <p>京公网安备 11010802034916号</p>
      </div>
      <div class="right_box d_flex">
        <div class="d_flex flex_column align_items_center">
          <img src="@/assets/common/official_account.jpg" alt="" srcset="" />
          <p>微信公众号</p>
        </div>
        <div class="d_flex flex_column align_items_center">
          <img src="@/assets/common/mini_program.jpg" alt="" srcset="" />
          <p>微信小程序</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      data: [],
      navList: [
        { name: "首页", path: "/index" },
        { name: "产品中心", path: "/product/list" },
        { name: "合作加盟", path: "/cooperation-join" },
        { name: "关于我们", path: "/about-us" },
        { name: "常见问题", path: "/faq/list" }
      ]
    };
  },
  methods: {
    toAboutUsPage() {
      this.$router.push("/about-us");
    },
    navItemClick(item) {
      if (item.path !== this.$route.path) {
        this.$router.push(item.path);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.footer_box {
  height: 344px;
  background: #212121;
}

.left_box {
  p {
    font-size: 24px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 24px;
  }
  div {
    width: 176px;
    height: 40px;
    background: #fbe74e;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 500;
    color: #323232;
    line-height: 40px;
    cursor: pointer;
  }
}
.center_box {
  .nav_box {
    margin-bottom: 25px;
    .nav_item {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      margin-right: 45px;
      cursor: pointer;
    }
    :last-child {
      margin: 0;
    }
  }
  > p,
  > a {
    color: #ccc;
    font-size: 14px;
  }
}

.right_box {
  > div {
    margin-right: 30px;
  }
  img {
    width: 126px;
    margin-bottom: 20px;
  }
  p {
    color: #fff;
  }
}
</style>
